export const DASHBOARD = `/dashboard`;
export const DASHBOARD_EDIT_PASSWORD = `/dashboard/edit/password`;
export const POST_JOB = `/post-a-job`;
export const SIGN_IN = `/sign-in`;
export const PASSWORD_RESET = `/password/reset`;

export const UPLOAD_PROFILE_PHOTO = `/api/upload-profile-photo`;
export const UPLOAD_PROFILE_RESUME = `/api/upload-profile-resume`;

